import { useEffect } from 'react'
import { Desktop } from './Desktop'
import { Taskbar } from './Taskbar'
import { WindowManager } from './WindowManager'
import { StartMenu } from './StartMenu'
import { useDesktopStore } from '../../stores/desktopStore'
import { useWindowStore } from '../../stores/windowStore'

export function OSShell() {
  const startMenuOpen = useDesktopStore((state) => state.startMenuOpen)
  const openWindow = useWindowStore((state) => state.openWindow)

  // Open About window on first load (unless user previously closed it)
  useEffect(() => {
    openWindow('about', 'About Persona Science', 'info', { autoOpen: true })
  }, [])

  return (
    <>
      <Desktop />
      <WindowManager />
      {startMenuOpen && <StartMenu />}
      <Taskbar />
    </>
  )
}
